/**
 * 创建人：但志强
 * 时间：2019-3-29
 * 描述：为加载过度效果功能提供服务:创建和销毁遮罩层
 * 使用说明: 参考 sw-loadingmask 配置应用说明文档
 * 更新记录: 
 */
import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwLoadingmaskComponent } from './sw-loadingmask.component';
@Injectable({
  providedIn: 'root'
})
export class SwLoadingmaskService {

  SwLoadingmaskComponentRef:any;
  com:any
  status:string
  timer:any
  constructor(
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver
    ) { }

  
    //关闭加载框
    closeLoading(){ 
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if(this.SwLoadingmaskComponentRef && this.com && this.status == 'open'){
        this.SwLoadingmaskComponentRef.instance.closeLoading()
        document.body.removeChild(this.com);
        this.applicationRef.detachView(this.SwLoadingmaskComponentRef.hostView);
        this.SwLoadingmaskComponentRef.destroy()
        this.status = 'close'
      }
  }
  //打开加载框
    openLoading(title?, autoCloseMs = 8000){ 
      this.closeLoading();
      //创建dom 节点
      this.com = document.createElement(SwLoadingmaskComponent.name);
      //创建动态组件
      const factory = this.componentFactoryResolver.resolveComponentFactory(SwLoadingmaskComponent);
     
      this.SwLoadingmaskComponentRef = factory.create(this.injector, [], this.com);
      this.applicationRef.attachView(this.SwLoadingmaskComponentRef.hostView);
      document.body.appendChild(this.com);
      if(title){
        this.SwLoadingmaskComponentRef.instance.title=title;
      }else{
        this.SwLoadingmaskComponentRef.instance.title='正在加载中...';
      }
     
      this.SwLoadingmaskComponentRef.instance.openLoading()
      this.status = 'open'
      if (autoCloseMs > 0) {
        this.timer = setTimeout(() => {
          this.closeLoading()
        }, autoCloseMs);
      }
  }

}
